import { types } from 'mobx-state-tree';

import REWARD_TYPES from '../definitions/RewardTypes';
import SCENARIOS from '../definitions/Scenarios';
import PRODUCT_TYPES from '../definitions/ProductTypes';
import TRAVEL_FEATURES from '../definitions/TravelFeatures';
import SORT_ORDER from '../definitions/SortOrder';
import USER_CATEGORIES from '../definitions/UserCategories';
import TopCard from './TopCard';


const CardPreference = types
    .model('CardPreference', {
        scenario: types.maybeNull(types.enumeration(Object.values(SCENARIOS))),
        rewardType: types.maybeNull(types.enumeration(Object.values(REWARD_TYPES))),
        requestedTypes: types.array(types.enumeration(Object.values(PRODUCT_TYPES))),
        fallbackTypes: types.array(types.enumeration(Object.values(PRODUCT_TYPES))),
        monthlySpendingAverage: types.maybeNull(types.string),
        monthlySpending: types.maybeNull(types.model('MonthlySpending', {
            groceries: types.integer,
            gas: types.integer,
            restaurants: types.integer,
            bills: types.integer,
            travel: types.integer,
            entertainment: types.integer,
            pharmacy: types.integer,
            other: types.integer,
        })),
        userCategory: types.maybeNull(types.enumeration(Object.values(USER_CATEGORIES))),
        transferAmount: types.maybe(types.integer),
        creditBalance: types.maybe(types.integer),
        features: types.maybe(types.array(types.enumeration(Object.values(TRAVEL_FEATURES)))),
        topCards: types.array(TopCard),
        isHighBalance: types.maybeNull(types.boolean),
        noAnnualFee: types.maybeNull(types.boolean),
        requiresGiftOffer: types.maybeNull(types.boolean),
        sortOrder: types.optional(types.enumeration(Object.values(SORT_ORDER)), SORT_ORDER.DEFAULT),
    });

export default CardPreference;
